import { render, staticRenderFns } from "./GridForm.vue?vue&type=template&id=18e27c1d"
import script from "./GridForm.vue?vue&type=script&lang=js"
export * from "./GridForm.vue?vue&type=script&lang=js"
import style0 from "./GridForm.vue?vue&type=style&index=0&id=18e27c1d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports